<template>
  <router-view />
</template>
<script>
export default {
  name: "App",
  created() {
    // The /assets routes (screenshot iframe, open-in-new-tab) authenticate with an HttpOnly cookie the
    // API sets from the stored JWT. Once per page load covers login (a full reload), sessions that
    // predate the cookie, and the cookie expiring with the token (DM-10602).
    if (this.$api.getPythonApiToken()) {
      this.$api.syncSessionCookie();
    }
  },
};
</script>
<style>
  .modal-backdrop {
      /* bug fix - no overlay */    
      display: none;    
  }
</style>